export function ajaxPaginationInit() {
	const loadMoreBtn = document.querySelector( '#ajax-load-more-posts' );
	const postsContainer = document.querySelector( '#ajax-display-more-posts' );

	if ( ! loadMoreBtn || ! postsContainer ) {
		return;
	}

	// Bind events.
	loadMoreBtn.addEventListener( 'click', async function ( event ) {
		event.preventDefault();

		this.classList.add( 'pp-button--loading' );

		if (
			! this.dataset.hasOwnProperty( 'post_type' ) ||
			! this.dataset.hasOwnProperty( 'posts_template' ) ) {
			return;
		}

		let queryVars  = this.dataset;
		
		if ( ! queryVars.hasOwnProperty( 'paged' ) || queryVars.paged === 0 ) {
			queryVars.paged = 2;
		} else {
			queryVars.paged++;
		}

		console.log( queryVars );

		fireAjaxRequest( queryVars ).then( ( response ) => {
			if ( response.success ) {
				postsContainer.insertAdjacentHTML( 'beforeend', response.data.html );
				loadMoreBtn.classList.remove( 'pp-button--loading' );

				if ( ! response.data.has_more ) {
					loadMoreBtn.style.display = 'none';
				}
			}
		} );
	} );
}

function fireAjaxRequest( queryVars ) {
	return new Promise( ( resolve, reject ) => {
		const xhr = new XMLHttpRequest();

		xhr.open( 'POST', ajaxSettings.ajaxURL, true );
		xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8' );

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4 && xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				resolve( response );
			}
		};

		xhr.onerror = function () {
			reject( {
				status: this.status,
				statusText: xhr.statusText,
			} );
		};

		const urlParams = new URLSearchParams();

		urlParams.append( 'action', 'load_more_posts' );
		urlParams.append( 'nonce', ajaxSettings.ajaxNonce );
		
		for ( const [ key, value ] of Object.entries( queryVars ) ) {
			urlParams.append( key, value );
		}

		xhr.send( urlParams );
	} );
}